/**
 * Tabs Module — generic tab switching
 *
 * Searches for [data-tab-trigger] and [data-tab-panel] within the
 * closest shared parent section (not necessarily the same container).
 */

export const Tabs = {
	initAll() {
		// Find all tab trigger groups and resolve their panels.
		const processed = new Set();

		document.querySelectorAll( '[data-tab-trigger]' ).forEach( ( trigger ) => {
			// Find the section-level parent to scope both triggers and panels.
			const section = trigger.closest( 'section' ) || trigger.closest( '[data-tabs]' ) || trigger.parentElement;
			if ( processed.has( section ) ) return;
			processed.add( section );
			if ( section.dataset.thriveTabsInit === '1' ) return; // Idempotent for editor re-mounts.
			section.dataset.thriveTabsInit = '1';

			const triggers = section.querySelectorAll( '[data-tab-trigger]' );
			const panels = section.querySelectorAll( '[data-tab-panel]' );

			triggers.forEach( ( t ) => {
				t.addEventListener( 'click', () => {
					const target = t.dataset.tabTrigger;

					triggers.forEach( ( tb ) => {
						tb.classList.toggle( 'is-active', tb === t );
						tb.setAttribute( 'aria-selected', tb === t ? 'true' : 'false' );
					} );

					panels.forEach( ( p ) => {
						const isTarget = p.dataset.tabPanel === target;
						p.hidden = ! isTarget;

						// Re-initialize any Swiper inside newly visible panel.
						if ( isTarget ) {
							const swiperEl = p.querySelector( '.swiper' );
							if ( swiperEl && swiperEl.swiper ) {
								swiperEl.swiper.update();
							}
						}
					} );
				} );
			} );
		} );
	},
};
